"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emptyData = {
    url: '',
    code: '',
};
class QR {
    constructor(data = emptyData) {
        this.url = data.url || '';
        this.code = data.code || '';
    }
    get imgSrc() {
        if (this.code)
            return `data:image/gif;base64,${this.code}`;
        return null;
    }
}
exports.default = QR;
